import request from "./model"
import { getDeviceUuid } from '../utils/fingerPrint'

// 初始化
export async function postBootstrap () {
  const device_uuid = await getDeviceUuid()
  return request.post('api/v2/bootstrap', { device_uuid })
}

// 月会员
export function productIndexNew () {
  return request.get('api/vip/products')
}

// 前往支付
export function payNew (id) {
  console.log('pid:', id);
  return request.post('api/vip/pay', {
    pid: id,
    order_type: 1,
    point_position_no: 3
  })
}

// 查询订单列表
export function record () {
  // return request.get('/api/user/recharge-logs?type=1&date=3&page=1')
  return request.get(`api/user/recharge-logs`, {
    params: {
      type: 1,
      date: 3,
      page: 1
    }
  })
}

// 身份卡查询
export function idCard () {
  return request.post('api/token/get_id_card')
}
